import auth from './auth';

class FinanceStore {
    constructor() {
        this.storagePrefix = 'financer_data_';
    }

    getStorageKey(key) {
        const user = auth.getCurrentUser();
        if (!user) return null;
        return `${this.storagePrefix}${user.id}_${key}`;
    }

    // Методы для работы с категориями
    getCategories() {
        const key = this.getStorageKey('categories');
        if (!key) return { expenses: [], income: [], goals: [] };
        
        try {
            const saved = localStorage.getItem(key);
            if (saved) {
                return JSON.parse(saved);
            }
        } catch (e) {
            console.error('Error loading categories:', e);
        }
        return { expenses: [], income: [], goals: [] };
    }

    setCategories(categories) {
        const key = this.getStorageKey('categories');
        if (!key) return;
        try {
            localStorage.setItem(key, JSON.stringify(categories));
        } catch (e) {
            console.error('Error saving categories:', e);
        }
    }

    // Методы для работы с транзакциями
    getTransactions() {
        const key = this.getStorageKey('transactions');
        if (!key) return { expenses: [], income: [], savings: [] };
        
        try {
            const saved = localStorage.getItem(key);
            if (saved) {
                const transactions = JSON.parse(saved);
                return {
                    expenses: transactions.expenses || [],
                    income: transactions.income || [],
                    savings: transactions.savings || []
                };
            }
        } catch (e) {
            console.error('Error loading transactions:', e);
        }
        return { expenses: [], income: [], savings: [] };
    }

    setTransactions(transactions) {
        const key = this.getStorageKey('transactions');
        if (!key) return;
        try {
            localStorage.setItem(key, JSON.stringify(transactions));
        } catch (e) {
            console.error('Error saving transactions:', e);
        }
    }

    // Методы для работы с заметками
    getNotes() {
        const key = this.getStorageKey('notes');
        if (!key) return [];
        
        try {
            const saved = localStorage.getItem(key);
            if (saved) {
                return JSON.parse(saved);
            }
        } catch (e) {
            console.error('Error loading notes:', e);
        }
        return [];
    }

    setNotes(notes) {
        const key = this.getStorageKey('notes');
        if (!key) return;
        try {
            localStorage.setItem(key, JSON.stringify(notes));
        } catch (e) {
            console.error('Error saving notes:', e);
        }
    }

    // Очистка всех данных текущего пользователя
    clearAll() {
        const userId = auth.getCurrentUser()?.id;
        if (!userId) return;

        const keys = [
            this.getStorageKey('categories'),
            this.getStorageKey('transactions'),
            this.getStorageKey('notes')
        ];

        keys.forEach(key => {
            if (key) localStorage.removeItem(key);
        });
    }
}

const store = new FinanceStore();
export default store;
